import { call } from "typed-redux-saga";

import {
	maybeAsyncFnWrapper,
	OverviewEngineDataLoader,
	OverviewEngineFactories,
	ProvideDataParams
} from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/client-extensions";
import { ProvideDataResults } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/client-extensions/internal/data-loader/data-loader";

import { fristLoader } from "../../modules/fristen/overviewLoader";
import { linksLoader } from "../../modules/links/overviewLoader";
import { processOverviewLoader } from "../../modules/processOverview/processOverviewLoader";
import { wiedervorlagenLoader } from "../../modules/wiedervorlagen/wiedervorlagenOverviewLoader";
import { wiedervorlagenWithProcessOverviewLoader } from "../../modules/wiedervorlagen/wiedervorlagenWithProcessOverviewLoader";
import { stammdatenLoader } from "../../modules/stammdaten/stammdatenOverviewLoader";

import { ModulfOverviewEngineDataLoader } from "./modulfOverviewEngineDataLoader";

const modulfOverviewEngineDataLoaders: ModulfOverviewEngineDataLoader[] = [
	fristLoader,
	wiedervorlagenLoader,
	wiedervorlagenWithProcessOverviewLoader,
	linksLoader,
	processOverviewLoader,
	stammdatenLoader
];

export const overviewEngineDataLoader: OverviewEngineDataLoader = {
	*provideData(params: ProvideDataParams): ProvideDataResults {
		const [...otherQueries] = params.queries;

		for (const modulfOverviewEngineDataLoader of modulfOverviewEngineDataLoaders) {
			const canHandle = yield* call(modulfOverviewEngineDataLoader.canHandle, params);
			if (canHandle) {
				return yield* call(modulfOverviewEngineDataLoader.provideData, params);
			}
		}

		return yield* call(maybeAsyncFnWrapper(OverviewEngineFactories.dataLoader.provideData), {
			...params,
			queries: [...otherQueries]
		});
	}
};
